<template>
  <PageHeader :showBreadcrumb="true" />
  <form v-if="authStore.isAdminUser && appStore.entities.length > 0" @submit.stop.prevent="onSubmit">
    <div class="container">
      <DataTable v-model:filters="filters" :value="adminAudits" ref="adminAuditLogTable" dataKey="id"
                 stripedRows :loading="loading" paginator :rows="25" sortField="createdAt" :sortOrder="-1">
        <template #header>
          <div class="header-components gap-3">
            <IconField>
              <InputText v-model="filters['global'].value" label="Keyword Search" aria-label="Keyword Search" placeholder="Keyword Search" />
              <InputIcon>
                <i class="pi pi-search" ></i>
              </InputIcon>
            </IconField>
            <Button icon="pi pi-external-link" rounded label="Export" @click="exportCSV($event)" />
          </div>
        </template>
        <template #empty> No Data. </template>
        <Column field="emailActor" header="Actor" sortable/>
        <Column field="emailTarget" header="Target" sortable/>
        <Column field="description" header="Action Taken" sortable/>
        <Column field="value" header="Value" sortable/>
        <Column field="createdAt" header="Timestamp" sortable/>
      </DataTable>
    </div>
  </form>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import PageHeader from "@/components/common/PageHeader.vue";
import {useAppStore} from "@/stores/appStore.js";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from "primevue/button";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";
import {useAuthStore} from "@/stores/authStore.js";
import {FilterMatchMode} from '@primevue/core/api';
import {getAdminAudits} from "@/services/adminAuditService.js";

const appStore = useAppStore();
const authStore = useAuthStore();

const adminAudits = ref([]);
const adminAuditLogTable = ref();
const loading = ref(true);

const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const exportCSV = () => {
  adminAuditLogTable.value.exportCSV();
};

const getAdminAuditLogData = async () => {
  const auditLog = await getAdminAudits();
  auditLog.forEach((e) => {
    if (e.createdAt) {
      e.createdAt = new Date(e.createdAt).toLocaleString();
    } else {
      e.createdAt = '—';
    }
  });
  adminAudits.value = auditLog;
};

onMounted(() => {
  getAdminAuditLogData().then(() => {loading.value = false;});
});
</script>

<style scoped>
.tx-p {
  padding: 1.5rem;
  height: 200px;
}

.header-components {
  display: flex;
  justify-content: flex-end;
}
</style>